//--------------------------
// calc improvement maximum
//--------------------------
export default function calcImprovMax(parm) {
  // console.log("----------------------");
  // console.log("IN calcImprovMax");
  // console.log("PARM = ", parm)

  const max = Number(parm.max) || 0;
  const integs_tot = Number(parm.integs_tot) || 0;
  const rolled = Number(parm.rolled) || 0;

  let result;
  if ('integs_tot' in parm) {
    result = max - integs_tot - rolled;
  } else {
    result = max - rolled;
  }
  // console.log('calcImprovMax = ', result)
  return result
}
